import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { DatePicker } from '../../../../../atoms';
import { DEFAULT_DATE_FORMAT } from '../../../../../constants';

type Props = {
  value: any;
  onChange: (value)=>void;
}
const DatePickerControl:FC<Props> = ({ value, onChange }) => {
  // const onChange = (value) => {
  //   setInspectionFollowUp(value);
  //   if (isActivityTable) {
  //     columnFilterUi('followUp', formatDate(value, DEFAULT_DATE_FORMAT));
  //   } else {
  //     setFilter('followUp', formatDate(value, DEFAULT_DATE_FORMAT));
  //   }
  // }
  return (
    <DatePickerWrapper>
      <DatePicker
        portalPopper
        dateFormat={DEFAULT_DATE_FORMAT} // @ts-ignore
        selected={value}
        onChange={onChange}
      />
    </DatePickerWrapper>
  );
};

export default DatePickerControl;

// Note: the calendar popper is portalled to <body> (portalPopper), so its
// navigation-arrow styling lives in GlobalStyles under `.ep-datepicker-popper`,
// not here — scoped selectors no longer reach the portalled calendar.
const DatePickerWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const RemoveDateButton = styled.div`
  font-weight: bold;
  padding: 2px;
  font-size: 14px;
  cursor: pointer;
  margin-left: 5px;
`;
